import initRouter from '@src/router';
import mountApp from './mountApp';
import { handleCodeAndGetToken } from '@src/core/login';

Object.freeze(window.__TENANT_INFO__);

window.alert = () => {
	console.log('alert')
}
window.prompt = () => {
	console.log('prompt')
	return null
}
window.print = () => {
	console.log('print')
}

(async function main() {
	await handleCodeAndGetToken()
	const router = await initRouter();
	mountApp({ router });
})();
